import MDEditor from "@uiw/react-md-editor";

const MarkdownEditor = ({
	hideToolbar = false,
	height = 200,
	visibleDragbar = false,
	mode = "live", // or "preview"
	value,
	onChange,
}) => (
	<MDEditor
		hideToolbar={hideToolbar}
		height={height}
		visibleDragbar={visibleDragbar}
		preview={mode}
		value={value}
		onChange={onChange}
	/>
);

export default MarkdownEditor;
